import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import { ReactComponent as feature1 } from "../../../assets/icons/feature1.svg";
import { ReactComponent as feature2 } from "../../../assets/icons/feature2.svg";
import { ReactComponent as feature3 } from "../../../assets/icons/feature3.svg";
import { ReactComponent as feature4 } from "../../../assets/icons/feature4.svg";
import { ReactComponent as feature5 } from "../../../assets/icons/feature5.svg";
import { ReactComponent as feature6 } from "../../../assets/icons/feature6.svg";
 
const features = [
  {
    icon: feature1,
    title: " 自社の業務に合わせた画面を\n見やすいデザインで",
    text: "React／TypeScriptで画面を作り込むため、「いかにもSharePoint」という見た目にはなりません。業務の流れに合わせた画面構成にでき、PCでもタブレットでも表示が崩れません。",
  },
  {
    icon: feature2,
    title: "いま使っている\nMicrosoft 365ツールとつながる",
    text: "Power BIのレポートをポータルに埋め込む、Power Automateの承認フローとつなぐ、Copilotから社内情報を引けるようにする。すでにお使いのM365ツールと同じ画面の中でつなぎます。",
  },
  {
    icon: feature3,
    title: "待たされない表示スピード",
    text: "描画をクライアントサイドで行い、データの取得範囲も必要な分だけに絞ります。件数の多い一覧やページ切り替えでの待ち時間が短くなり、「重くて使わなくなる」状態を避けられます。",
  },
  {
    icon: feature4,
    title: "いまのセキュリティ設定を\nそのまま引き継ぐ",
    text: "ログインは既存のAzure AD（Entra ID）のまま、多要素認証や条件付きアクセスといった現在の社内ポリシーもそのまま適用されます。監査ログもM365側に残るため、情報システム部門の管理対象を増やしません。",
  },
  {
    icon: feature5,
    title: "PCでもスマホでも同じように使える",
    text: "PCのブラウザに加えて、TeamsのタブやSharePointモバイルアプリからも同じ機能を使えます。工場や店舗、外出先からの入力・確認を前提とした画面にもできます。",
  },
  {
    icon: feature6,
    title: "毎月の固定費が増えない",
    text: "アプリもデータもSharePointの中に置くため、サーバーの調達や監視、OSの更新作業が発生しません。月々かかるのは、すでにお持ちのM365ライセンスだけです。",
  },
];
 
const FeaturesSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F4F5F6",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth={false} sx={{ width: "92%", mx: "auto" }}>
        <Typography
          sx={{
            color: "#FF6000",
            fontWeight: 700,
            fontSize: "13px",
            letterSpacing: "1px",
            mb: 1,
          }}
        >
          FEATURES
        </Typography>
 
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: "26px", md: "50px" },
            mb: 1.5,
          }}
        >
          サービスの特徴（選ばれる理由）
        </Typography>
 
        <Typography
          sx={{
            fontSize: "20px",
            color: "rgba(0,0,0,0.65)",
            mb: { xs: 4, md: 5 },
          }}
        >
          SPFxの開発経験とMicrosoft 365の運用知識、その両方を持つチームが担当します
        </Typography>
 
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: { xs: 3, md: 4 },
          }}
        >
          {features.map((item, index) => {
            const FeatureIcon = item.icon;
 
            return (
              <Paper
                key={index}
                elevation={0}
                sx={{
                  height: "100%",
                  boxSizing: "border-box",
                  backgroundColor: "#616B78",
                  color: "#fff",
                  borderRadius: "12px",
                  border: "1px solid rgba(255,255,255,0.06)",
                  p: 3.5,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    mb: 2.5,
                  }}
                >
                  <FeatureIcon sx={{ fontSize: 30, color: "#fff" }} />
                </Box>
 
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "20px",
                    lineHeight: 1.6,
                    mb: 1.5,
                    whiteSpace: { xs: "normal", sm: "pre-line" },
                  }}
                >
                  {item.title}
                </Typography>
 
                <Typography
                  sx={{
                    fontSize: "14px",
                    lineHeight: 1.8,
                    color: "rgba(255,255,255,0.75)",
                  }}
                >
                  {item.text}
                </Typography>
              </Paper>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};
 
export default FeaturesSection;